export default function () {
  return {
    isLoading: true,
    data: {},
    processSteps: ['input', 'transformations', 'output']
  }
}
